import script from "./ProntuarioComp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProntuarioComp.vue?vue&type=script&setup=true&lang=ts"

import "./ProntuarioComp.vue?vue&type=style&index=0&id=a151219e&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a151219e"]])

export default __exports__